import React from 'react';
import './PetAnimations.css';

export default function CowSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#F0EDE8';
  const lightColor = color ? lighten(color) : '#FFFFFF';
  const darkColor = color ? darken(color) : '#D0CDC8';
  const patchColor = '#6B4226';
  const skinColor = '#E8C8A8';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail */}
      <path
        d="M88 60C96 56 100 50 98 46"
        stroke={bodyColor}
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      <ellipse cx="98" cy="44" rx="3" ry="4" fill={patchColor} />
      {/* Body */}
      <ellipse cx="58" cy="68" rx="30" ry="24" fill={bodyColor} />
      {/* Brown patches */}
      <ellipse cx="46" cy="62" rx="10" ry="8" fill={patchColor} opacity="0.8" />
      <ellipse cx="72" cy="66" rx="8" ry="10" fill={patchColor} opacity="0.8" />
      <ellipse cx="58" cy="78" rx="7" ry="5" fill={patchColor} opacity="0.6" />
      {/* Belly */}
      <ellipse cx="58" cy="78" rx="16" ry="10" fill={lightColor} />
      {/* Udder hint */}
      <ellipse cx="62" cy="88" rx="6" ry="3" fill={skinColor} />
      {/* Legs */}
      <rect x="36" y="86" width="8" height="14" rx="3" fill={bodyColor} />
      <rect x="48" y="88" width="7" height="12" rx="3" fill={bodyColor} />
      <rect x="66" y="88" width="7" height="12" rx="3" fill={bodyColor} />
      <rect x="78" y="86" width="8" height="14" rx="3" fill={bodyColor} />
      {/* Hooves */}
      <rect x="36" y="97" width="8" height="4" rx="2" fill="#3A3A3A" />
      <rect x="48" y="97" width="7" height="4" rx="2" fill="#3A3A3A" />
      <rect x="66" y="97" width="7" height="4" rx="2" fill="#3A3A3A" />
      <rect x="78" y="97" width="8" height="4" rx="2" fill="#3A3A3A" />
      {/* Head */}
      <ellipse cx="36" cy="44" rx="20" ry="18" fill={bodyColor} />
      {/* Head patch */}
      <ellipse cx="40" cy="38" rx="8" ry="6" fill={patchColor} opacity="0.7" />
      {/* Horns */}
      <path d="M24 32C22 24 18 20 16 22" stroke="#E8D8B0" strokeWidth="3" strokeLinecap="round" fill="none" />
      <path d="M48 32C50 24 54 20 56 22" stroke="#E8D8B0" strokeWidth="3" strokeLinecap="round" fill="none" />
      {/* Ears */}
      <ellipse cx="20" cy="38" rx="6" ry="4" fill={bodyColor} transform="rotate(-20 20 38)" />
      <ellipse cx="52" cy="38" rx="6" ry="4" fill={bodyColor} transform="rotate(20 52 38)" />
      <ellipse cx="20" cy="38" rx="4" ry="2.5" fill="#E8A0A0" transform="rotate(-20 20 38)" />
      <ellipse cx="52" cy="38" rx="4" ry="2.5" fill="#E8A0A0" transform="rotate(20 52 38)" />
      {/* Muzzle */}
      <ellipse cx="30" cy="50" rx="10" ry="8" fill={skinColor} />
      {/* Nostrils */}
      <circle cx="27" cy="50" r="2" fill={patchColor} opacity="0.6" />
      <circle cx="33" cy="50" r="2" fill={patchColor} opacity="0.6" />
      {/* Eyes */}
      <circle cx="28" cy="40" r="4" fill="white" />
      <circle cx="42" cy="40" r="4" fill="white" />
      <circle cx="29" cy="40" r="2.5" fill="#3A2820" />
      <circle cx="43" cy="40" r="2.5" fill="#3A2820" />
      <circle cx="30" cy="39" r="1" fill="white" />
      <circle cx="44" cy="39" r="1" fill="white" />
      {/* Mouth */}
      <path d="M26 54C28 56 32 56 34 54" stroke={patchColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      {/* Bell on neck */}
      <rect x="34" y="56" width="6" height="2" rx="1" fill="#888" />
      <circle cx="37" cy="61" r="4" fill="#D4A830" />
      <circle cx="37" cy="61" r="2.5" fill="#E8C040" />
      <circle cx="37" cy="62" r="1" fill="#B08820" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
